import { render } from "./cs.vue?vue&type=template&id=af08bf0c&scoped=true"
import script from "./cs.vue?vue&type=script&lang=js"
export * from "./cs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-af08bf0c"

export default script